import styled from 'styled-components';
import { Icon } from '../../icon/Icon';

interface SurveyOverviewNavigationItemProps {
  label: string;
  inputValue: string | number;
  onClickHandler: () => void;
  isActive?: boolean;
}

export const SurveyOverviewNavigationItem = ({
  label,
  inputValue,
  onClickHandler,
  isActive = false,
}: SurveyOverviewNavigationItemProps) => {
  return (
    <Container onClick={onClickHandler}>
      <Label>{label}</Label>
      <InputValue isActive={isActive}>{inputValue}</InputValue>
      <Icon name={'AngleRightDarkGray'} width={14} height={14} />
    </Container>
  );
};

const Container = styled.li`
  display: flex;
  padding: var(--radius-large, 16px) 0px;
  border-bottom: 1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed);

  align-items: center;
  gap: 10px;
  align-self: stretch;

  cursor: pointer;
`;

const Label = styled.span`
  color: #000;
  flex: 1 0 0;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */
`;

const InputValue = styled.span<{ isActive: boolean }>`
  color: ${(props) =>
    props.isActive
      ? 'var(--Light-Scheme-Monochrome-black, #232429)'
      : 'var(--Light-Scheme-Monochrome-grey70, #a7a9b6)'};
  text-align: center;

  /* Display/Large/l-regular */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 20.8px */
`;
